import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const { GET_ALL_PTO_SUCCESS, GET_ALL_PTO_FAILURE } = getMyAvailabilityConstants;

const intitialstate: object = {
  getAllPtoRequest: false,
  response: null,
};

export const getAllPtoRequestReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_ALL_PTO_SUCCESS: {
      return {
        ...state,
        getAllPtoRequest: true,
        response: action.payload,
      };
    }

    case GET_ALL_PTO_FAILURE:
      return {
        ...state,
        getAllPtoRequest: false,
        response: action.payload,
      };

    default:
      return state;
  }
};
